import React from 'react'

const ProgressBar = ({ loaded = 0, total, label }) => {
  const percentage = total ? Math.min(100, Math.round((loaded / total) * 100)) : 0

  return (
    <div className="bulk-edit-progress">
      <div className="bulk-edit-progress__track">
        <div className="bulk-edit-progress__fill" style={{ width: `${percentage}%` }} />
      </div>
      <span className="bulk-edit-progress__label">
        {label} {loaded}
        {total === null || total === undefined ? '' : ` of ${total}`}
      </span>
    </div>
  )
}

export default ProgressBar
